import React from 'react';
import { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { P } from '../../AbstractElements';

const Footer = () => {
    //footer-link
    const handleLinkClick = () => {
      window.open(`https://hofficecrm.com/`);
    };
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center">
            <div className="body-footer">
      <h3 className="footer-right">
        <span className="blue-text">Powered By: </span>
        <a className="green-text" href="https://hofficecrm.com" target="_blank">
          H-Office
        </a>
      </h3>
    </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;